module.exports = __webpack_public_path__ + "img/1.742024b5.png";